import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ReactAudioPlayer from "react-audio-player";
import { selectCurrentAudioURL } from "@/Redux/features/audioPlayer/audioPlayerSlice";
import { usePlayer } from "@/context/PlayerContext";

const Player = () => {
  const audioUrl = useSelector(selectCurrentAudioURL);
  const { isPlaying, setIsPlaying } = usePlayer();
  const [visible, setVisible] = useState(true);

  // State for volume
  const [volume, setVolume] = useState(0.1); // Initial volume level
  const audioRef = useRef(null);

  useEffect(() => {
    const audioElement = audioRef.current?.audioEl.current;
    if (audioElement) {
      audioElement.volume = volume;
      if (!isPlaying) {
        audioElement.pause();
      }
    }
  }, [volume, isPlaying]);

  const [play, setPlay] = useState(false);
  const [hasAudio, setHasAudio] = useState(false);

  const handlePlay = () => {
    setPlay(true);
  };

  const handlePause = () => {
    setPlay(false);
  };

  const handleVolumeChange = (e) => {
    setVolume(parseFloat(e.target.value));
  };

  const handleHide = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (!hasAudio) {
      setHasAudio(true);
    }
  }, [hasAudio]);

  return (
    <section>
      <section className={`${visible && isPlaying ? "block" : "hidden"} `}>
        <section
          className={`fixed bottom-0 w-full md:h-20 bg-blue-900 text-white flex items-center justify-center z-50`}
        >
          {/* Animated dots */}
          <div className="hidden lg:flex space-x-1 absolute right-20">
            {[...Array(8)].map((_, index) => (
              <div
                key={index}
                className={`w-1 h-4 bg-white rounded-full ${
                  play && "animate-ping"
                }`}
                style={{ animationDelay: `${index * 0.1}s` }}
              ></div>
            ))}
          </div>
          <div className="hidden lg:flex space-x-1 absolute right-4">
            {[...Array(8)].map((_, index) => (
              <div
                key={index}
                className={`w-1 h-4 bg-white rounded-full ${
                  play && "animate-ping"
                }`}
                style={{ animationDelay: `${(7 - index) * 0.1}s` }}
              ></div>
            ))}
          </div>
          <div className="hidden lg:flex space-x-1 absolute left-4">
            {[...Array(8)].map((_, index) => (
              <div
                key={index}
                className={`w-1 h-4 bg-white rounded-full ${
                  play && "animate-ping"
                }`}
                style={{ animationDelay: `${index * 0.1}s` }}
              ></div>
            ))}
          </div>
          <div className="hidden lg:flex space-x-1 absolute left-20">
            {[...Array(8)].map((_, index) => (
              <div
                key={index}
                className={`w-1 h-4 bg-white rounded-full ${
                  play && "animate-ping"
                }`}
                style={{ animationDelay: `${(7 - index) * 0.1}s` }}
              ></div>
            ))}
          </div>

          <div className="w-full max-w-screen-xl mx-auto md:flex items-center justify-center relative">
            <div className="flex justify-center">
              <button
                className="cursor-pointer my-5 text-lg px-4 py-1 border rounded-2xl bg-blue-800 opacity-90"
                onClick={handleHide}
              >
                Hide Player
              </button>
            </div>

            {/* Audio player */}
            {hasAudio && audioUrl && (
              <ReactAudioPlayer
                ref={audioRef}
                className="lg:w-2/3 mx-auto"
                src={audioUrl}
                autoPlay
                controls
                volume={volume}
                onPlay={handlePlay}
                onPause={handlePause}
              />
            )}

            {/* Volume control */}
            <div className="flex gap-2 justify-around my-5">
              <div className="bg-blue-300 dark:text-white rounded px-2 opacity-90">
                <p className="text-xl mr-2 text-center text-blue-900 font-bold">
                  Volume
                </p>
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.01"
                  value={volume}
                  onChange={handleVolumeChange}
                />
              </div>
            </div>
          </div>
        </section>
      </section>
      <section
        onClick={() => setVisible(true)}
        className={`w-2/12 h-5 ${
          isPlaying ? "block" : "hidden"
        } bg-blue-600 rounded-xl fixed bottom-1 right-1 text-xl p-4 cursor-pointer`}
      >
        {/* Animated dots */}
        
        <div className="hidden lg:flex space-x-1 absolute left-4 top-1/3 z-10">
          {[...Array(8)].map((_, index) => (
            <div
              key={index}
              className={`w-1 h-4 bg-white rounded-full ${
                play && "animate-ping"
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            ></div>
          ))}
        </div>
        <div className="hidden lg:flex space-x-1 absolute right-4 top-1/3 z-10">
          {[...Array(8)].map((_, index) => (
            <div
              key={index}
              className={`w-1 h-4 bg-white rounded-full ${
                play && "animate-ping"
              }`}
              style={{ animationDelay: `${(7 - index) * 0.1}s` }}
            ></div>
          ))}
        </div>
        <p className="absolute top-0 left-1/4 bg-blue-600 opacity-90 rounded-xl  text-center text-white z-20">Open Player</p>
      </section>
    </section>
  );
};

export default Player;
